export const SIDEBAR_EXPANDED_STORAGE_KEY = 'flightdeck-sidebar-expanded';

export function readSidebarExpanded(): boolean {
  try {
    return window.localStorage.getItem(SIDEBAR_EXPANDED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeSidebarExpanded(expanded: boolean): void {
  try {
    window.localStorage.setItem(
      SIDEBAR_EXPANDED_STORAGE_KEY,
      String(expanded)
    );
  } catch {
    // Ignore quota / private-mode failures
  }
}
